module.exports = __webpack_public_path__ + "static/media/chase-porter-home-warranty-review_160px.6c1e88f5.jpg";